import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/patientImages',
  	  method: 'get',
        params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/patientImages/inventory',
      method: 'get',
      params
    })
  }
  
export function show(id) {
    return request({
      url: `/patientImages/${id}`,
      method: 'get'
    })
  }

  export function storeFile(data) {
    return request({
      url: '/patientImages',
      method: 'post',
      data
    })
  }
  export function storeImage(data) {
    return request({
      url: '/patientImages',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/patientImages/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/patientImages/${id}`,
      method: 'delete',
    })
  }
